<template>
  <td :class="[`cell-value-${col}`, 'text-center']">
    <font-awesome-icon :icon="prepareIcon(entry[col])" />
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: [String, Array],
  },
  methods: {
    prepareIcon(input) {
      if (input.indexOf(',') === -1) {
        return input;
      }
      const parts = input.split(',');
      return parts;
    },
  },
};
</script>
